declare global {
  interface Window {
    PopupMessage: any;
  }
}

export function extendPopupMessage() {
  if (lib.comsuntexsymbolsPopupMessage) {
    window.PopupMessage = lib.comsuntexsymbolsPopupMessage;

    const comsuntexsymbolsPopupMessage_constructor =
      lib.comsuntexsymbolsPopupMessage;
    const comsuntexsymbolsPopupMessage_prototype =
      lib.comsuntexsymbolsPopupMessage.prototype;

    lib.comsuntexsymbolsPopupMessage = function () {
      this._oldConstructor = comsuntexsymbolsPopupMessage_constructor;
      this._oldConstructor();

      this.animMs = 300;
      this.delayMs = 2000;
      this.messageText = UIUtil.find(this, 'messageText');

      UIUtil.disable(this);
      UIUtil.hide(this);
      UIUtil.scaleTo(this, 0.0);
      UIUtil.fadeTo(this.messageText, 0.0);
    };
    lib.comsuntexsymbolsPopupMessage.prototype =
      comsuntexsymbolsPopupMessage_prototype;

    const p = lib.comsuntexsymbolsPopupMessage.prototype;

    p.setText = function (message) {
      this.messageText.text = message;
    };

    p.display = function () {
      this._popUp();
    };

    p._popUp = function () {
      UIUtil.show(this);
      UIUtil.scaleTo(this, 1.0, this.animMs);
      UIUtil.delay(this._showMessage, this.animMs, [], this);
    };

    p._showMessage = function () {
      UIUtil.fadeTo(this.messageText, 1.0, this.animMs);
      UIUtil.delay(this._hideMessage, this.delayMs, [], this);
    };

    p._hideMessage = function () {
      UIUtil.fadeTo(this.messageText, 0.0, this.animMs);
      UIUtil.delay(this._popDown, this.animMs, [], this);
    };

    p._popDown = function () {
      UIUtil.scaleTo(this, 0.0, this.animMs);
      UIUtil.delay(this._done, this.animMs, [], this);
    };

    p._done = function () {
      UIUtil.hide(this);
    };
  }
}
